module.exports = __webpack_public_path__ + "Flag-4.8f9b20032670f116e15565dbea518cd3.svg";